export const environment = {
  production: true,
  appVersion: 'v2.10.0',
  USERDATA_KEY: 'testlaplus',
  isMockEnabled: true,
  apiUrl: '/api/v2',
  froalaLicenseKey: 'yDC5hB3E3B11D6B4F6A5g1JWSDBCQG1ZGDf1C1d2JXDAAOZWJhE5B4E4I3F2H3B7A4B4F4==',
  mercadoPagoPublicKey: 'APP_USR-f59f4916-2740-4b60-ab85-315f9215e7f7'
  // apiUrl: 'mysite.com/api'
};
